<template>
    <div class="about-rp">
        <h3 class="indent">Coil Casting</h3>
        <p class="indent">Alcomet’s cast house is equipped with seven continuous casting lines with a total annual capacity of 96,000 tonnes. The facility produces a wide range of 1xxx, 3xxx, 5xxx, and 8xxx series alloys, supporting the production of aluminium foil, sheets, and strips for diverse industrial applications.</p>
        <p class="indent">Alloys are produced in accordance with international standards, including EN 573-3, as well as customer-specific and internally developed specifications. Strict control of chemical composition and casting parameters ensures consistent quality and reliable performance
          throughout the subsequent production processes.
        </p>
        <div class="about-rp-table">
          <div class="about-rp-table-row">
            <span>Strip thickness:</span>
            <span>5 - 10 mm</span>
          </div>
          <div class="about-rp-table-row">
            <span>Strip width max:</span>
            <span>max. 1800 mm</span>
          </div>
          <div class="about-rp-table-row">
            <span>Available alloys:</span>
            <span>1xxx, 3xxx, 5xxx, 8xxx series</span>
          </div>
        </div>
        <img class="about-rp-img" src="/static/img/about/rp/1.jpg" alt="Rolling">
        <h3 class="indent">Rolling</h3>
        <p class="indent">Alcomet’s rolling division combines advanced cold-rolling and foil-breakdown
          technologies with precision finishing processes including slitting, degreasing,
          cut-to-length, and embossing. The division produces battery foil, household
          foil, container foil, converter foil, technical foil, finstock, sheets, and strips for
          packaging, automotive, construction, HVAC, and industrial applications.</p>
        <p class="indent">In 2026, Rolling Shop 2 was expanded with a new ACHENBACH OPTIMILL®
          4-HIGH NON-REVERSING BATTERY FOIL ROLLING MILL, strengthening
          Alcomet’s capabilities in high-performance and thin-gauge aluminium foil.</p>
      <p class="indent">With a combined rolling capacity of 115,000 tonnes per year, Alcomet combines
        advanced technology, production flexibility, and consistent quality across its
        comprehensive range of rolled products.</p>

      <div class="about-rp-table">
        <div class="about-rp-table-row">
          <span>Annual capacity</span>
          <span>115 000 tonnes</span>
        </div>
        <div class="about-rp-table-row">
          <span>Thickness range</span>
          <span>0.006 - 3.5 mm | 0.000236" - 0.137"</span>
        </div>
        <div class="about-rp-table-row">
          <span>Width</span>
          <span>up to 2.2 meters | 86.61"</span>
        </div>
        <div class="about-rp-table-row">
          <span>Alloys series</span>
          <span>1xxx, 3xxx, 5xxx, 8xxx</span>
        </div>
      </div>

      <div class="about-au-img">
        <img v-scroll-reveal.reset src="/static/img/about/rp/1/1.jpg" alt="">
        <img v-scroll-reveal.reset="{ delay: 250 }" src="/static/img/about/rp/1/2.jpg" alt="">
        <img v-scroll-reveal.reset="{ delay: 500 }" src="/static/img/about/rp/1/3.jpg" alt="">
        <p v-scroll-reveal.reset="{ delay: 750 }" class="about-au-img-p"></p>
      </div>
        <app-share-button></app-share-button>
    </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
export default {
  components: {
    appShareButton: ShareButton
  }
};
</script>

<style scoped>
.about-rp {
  align-items: center;
  display: flex;
  flex-direction: column;
}
.about-rp > p {
  font-size: 19px;
  line-height: 32px;
  margin: 15px auto;
  text-align: justify;
  width: 60%;
}
.about-rp > h3 {
  font-size: 22px;
  font-weight: 500;
  line-height: 32px;
  margin: 15px auto;
  text-align: justify;
  width: 60%;
}
.about-rp-table {
  margin: 15px 0;
  width: 60%;
}
.about-rp-table-row {
  align-items: center;
  background-color: #eef2f8;
  border-radius: 6px;
  display: flex;
  height: 50px;
  justify-content: space-between;
  margin-bottom: 8px;
  padding: 0 20px;
  width: 100%;
}
.about-rp-table-row > span {
  font-weight: 700;
  font-size: 16px;
  color: #1a437c;
}
.about-rp-img {
  border-radius: 5px;
  height: auto;
  margin: 20px auto;
  min-height: 1px;
  width: 80%;
}
@media screen and (max-width: 1000px) {
  .about-rp p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
  .about-rp-table,
  .about-rp > h3 {
    width: 100%;
    padding: 0 30px;
  }
  .about-rp-img {
    width: calc(100% - 60px);
  }
}
@media screen and (max-width: 600px) {
  .about-rp-table-row > span {
    font-size: 12px;
  }
  .about-rp-table-row > span:last-child {
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/about/RollingPlant.vue